<shakespeare-spinning-loader *ngIf="loading"></shakespeare-spinning-loader>

<div class="container" *ngIf="!loading">
	<!-- <app-button (onClick)="goToCreative()">Go to Creative</app-button>
	<app-button (onClick)="goToGoogleAuth()">Go to Ad Intelligence</app-button> -->
	<shakespeare-spinning-loader></shakespeare-spinning-loader>
</div>
